import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledLabel, StyledNoteRow, StyledRow, StyledValue } from './summary-information-row.styled';

interface Note {
    label: string;
    value?: React.ReactNode;
}

interface SummaryInformationRowProps {
    label: string;
    value?: string;
    note?: Note;
    isValueSensitive?: boolean;
}

export const SummaryInformationRow: FunctionComponent<SummaryInformationRowProps> = (props) => {
    const { label, value, note, isValueSensitive } = props;

    const renderNote = (): React.ReactNode =>
        note && (
            <StyledNoteRow>
                <StyledLabel component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
                    {note.label}
                </StyledLabel>
                {note.value}
            </StyledNoteRow>
        );

    return (
        <StyledContainer>
            <StyledRow>
                <StyledLabel component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
                    {label}
                </StyledLabel>
                {value && (
                    <StyledValue
                        component="p"
                        variant="paragraph2"
                        maxBreakpoint={Breakpoint.TABLET}
                        data-hj-suppress={isValueSensitive}
                    >
                        {value}
                    </StyledValue>
                )}
            </StyledRow>
            {renderNote()}
        </StyledContainer>
    );
};
